export const fontStyle = {
  fontFamily: "Avenir Next",
};

export const colors = {
  lightest_blue: "#EFFAFF",
  lighter_blue: "#46B4FF",
  light_blue: "#0098FF",
  blue: "#007fd6",
  grayest: '#656565',
  gray: "#EBEBEB",
  newGray: "#F5F5F5",
  dark_gray: "#BABABA",
  darkest_gray: "#656565",
  dark: "#363636",
  darkest: "#191919",
  red: '#FF0000'
};
export const zIndexes = {
  defaultAbsolute: 10,
  backdrop: 30,
  drawer: 9999,
};
